import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { HistoricVar } from "../../devices/device.model";
import { EnergyService } from "../energy.service";
import { SharedUtils } from "../../../shared/shared.utils";
import { GeneralService } from "../../../shared/services/general.service";
import { DevicesService } from "../../devices/devices.service";
import { SessionStateService } from "../../../core/services/session-state.service";
import { Observable } from "rxjs";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-energy-generation",
  templateUrl: "./energy-generation.component.html",
  styleUrls: ["./energy-generation.component.scss"],
})
export class EnergyGenerationComponent implements OnInit, OnChanges {
  @Input() autoConsumption: boolean;
  @Input() viewMode: string;
  loaded = false;
  varStats: Map<string, HistoricVar>;
  todayValue: number | string;
  monthValue: number | string;
  SharedUtils = SharedUtils;
  constructor(
    private sessionStateService: SessionStateService,
    private energyService: EnergyService,
    private devicesService: DevicesService
  ) {}

  ngOnChanges() {
    this.refreshValues();
  }

  ngOnInit() {
    this.refreshValues();
  }

  refreshValues() {
    this.loaded = false;
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .subscribe((smartMeter: any) => {
        this.energyService
          .getTotals(this.sessionStateService.getHouse().houseId)
          .catch((err) => {
            this.todayValue = "-";
            this.monthValue = "-";
            this.loaded = true;
            return of(empty);
          })
          .subscribe((totals) => {
            if (this.viewMode === "Eur") {
              if (totals["production"]) {
                this.todayValue =
                  totals["production"]["today"]["cost"] !== "-,--" &&
                  totals["production"]["today"]["cost"] >= 0.1
                    ? totals["production"]["today"]["cost"]
                    : "-";
                this.monthValue =
                  totals["production"]["thisMonth"]["cost"] !== "-,--" &&
                  totals["production"]["thisMonth"]["cost"] >= 0.1
                    ? totals["production"]["thisMonth"]["cost"]
                    : "-";
              }
            } else {
              if (totals["production"]) {
                this.todayValue =
                  totals["production"]["today"]["value"] !== "-,--" &&
                  totals["production"]["today"]["cost"] >= 0.1
                    ? totals["production"]["today"]["value"]
                    : "-";
                this.monthValue =
                  totals["production"]["thisMonth"]["value"] !== "-,--" &&
                  totals["production"]["thisMonth"]["cost"] >= 0.1
                    ? totals["production"]["thisMonth"]["value"]
                    : "-";
              }
            }

            this.loaded = true;
          });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-generation/energy-generation.component.ts